<!-- Coming Soon Component -->
<main class="comingsoon-container" role="main" aria-label="Coming Soon Page">
  <section class="comingsoon-content" aria-labelledby="comingsoon-title">
    <div class="comingsoon-icon" aria-hidden="true">
      <span class="comingsoon-clock">&#128336;</span>
    </div>
    <h1 id="comingsoon-title" class="comingsoon-title">Coming Soon</h1>
    <p class="comingsoon-navigation" aria-label="Navigation options">
      You can return to your
      <a routerLink="/businessProcess" class="dashboard-link" aria-label="Go to Dashboard">Dashboard</a>.
    </p>
  </section>
</main>
